    <template lang="html">

                <!-- Sidebar -->
            <div class="border-right" id="sidebar-wrapper">
                <div class="header-sidebar" slot="header">
                <img :src="basepath+'/unodc_logo.png'" alt="UNODC" style="width:200px" />
                </div>
                <div class="list-group list-group-flush"><span>
                <router-link :to="{ path: '/dashboard/Trainee/traineeDashboard', query: { training:this.trainingCode }}" class="list-group-item list-group-item-action">
                <i class="material-icons" >ballot</i> Trainee Dashboard
                </router-link>
                </span>
                <span v-if="preAssesment == true">
                <router-link :to="{path: '/dashboard/Trainee/preassessment', query: { training:this.trainingCode}}"  class="list-group-item list-group-item-action">
                <i class="material-icons" >assignment_late</i> Pre Assessment
                </router-link>
                </span>
                <span class="disabled" v-else>
                <router-link :to="{path: '/dashboard/Trainee/preassessment', query: { training:this.trainingCode}}"  class="list-group-item list-group-item-action">
                <i class="material-icons" >assignment_late</i> Pre Assessment
                </router-link>
                </span>
                <span v-if="postAssesment == true">
                <router-link :to="{path: '/dashboard/Trainee/postassessment', query: { training:this.trainingCode}}" class="list-group-item list-group-item-action">
                <i class="material-icons">assignment_turned_in</i> Post Assessment
                </router-link>
                </span>
                <span class="disabled" v-else>
                <router-link :to="{path: '/dashboard/Trainee/postassessment', query: { training:this.trainingCode}}" class="list-group-item list-group-item-action">
                <i class="material-icons">assignment_turned_in</i> Post Assessment
                </router-link>
                
                </span>
                <span v-if="traineefeedback == true">

                <router-link :to="{path: '/dashboard/Trainee/feedback', query: { training:this.trainingCode}}" class="list-group-item list-group-item-action">
                <i class="material-icons">feedback</i> Feedback
                </router-link>
                </span>
                <span class="disabled" v-else>

                <router-link :to="{path: '/dashboard/Trainee/feedback', query: { training:this.trainingCode}}" class="list-group-item list-group-item-action">
                <i class="material-icons">feedback</i> Feedback
                </router-link>
                </span>
                <!-- <span v-if="certificates == true"> -->

                <router-link :to="{path: '/dashboard/Trainee/certificates', query: { training:this.trainingCode}}" class="list-group-item list-group-item-action">
                <i class="material-icons">card_membership</i> Certificate
                </router-link>

                <router-link :to="{path: '/dashboard/Trainee/gallery', query: { training:this.trainingCode}}"  class="list-group-item list-group-item-action">
                <i class="material-icons">perm_media</i> Evenet Gallery
                </router-link>

                </div>
                </div>
               </template>

<script>
import axios from "axios";


export default {
  data: () => ({
    active: true,
    preAssesment: "",
    traineefeedback: true,
    postAssesment: "",
    basepath: localStorage.getItem("BASE_PATH"),
    userId: JSON.parse(localStorage.getItem("currentUser")),
    trainingId: "",
    preAssessmentLink: false,
    postAssessmentLink: false,
    profileSettings: true,
    addReference: false,
    // knowledgeBaseRepository:false,
    feedback: false,
    certificates: false,
    feedbackQuestions: [],
    feedbackQuestionOptions: [],
    trainingCode: "",
    gallery: false
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingCode = this.$route.query.training;
    this.assessmentStatus();
  },
  created() {},
  methods: {
    assessmentStatus: function assessmentStatus() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/check-assesment-status/" +
            this.trainingCode
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response && response.data) {
            this.preAssesment = response.data.preassesment_status;
            this.postAssesment = response.data.postassesment_status;
            this.traineefeedback = response.data.feedbackstatus;
          }
        });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    }
  }
};
</script>

<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.6;
}

body {
  overflow-x: hidden;
}
@media (min-width: 768px) {
  .sidebarx {
    display: block !important;
  }
  .vs-sidebar--background {
    z-index: 0 !important;
    background: transparent !important;
  }
}

@media (max-width: 768px) {
  .vs-sidebar--background {
    background: rgba(0, 0, 0, 0.2) !important;
  }
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */
</style>